import React from 'react';
import styled from 'styled-components';
import qboIcon from '~/assets/public/qbo-icon.png';
import { BackLink, Page } from '~/components';
import { useWorkspace } from '~/contexts';
import QBOSettingsPage from './QBOSettingsPage';

const QBOLogo = styled.img`
  width: 2.875rem;
  height: 2.875rem;
  max-width: unset;
`;

export default function QBOSettingsArea() {
  const { workspace } = useWorkspace();

  return (
    <Page>
      <Page.Header>
        <BackLink to={`/app/${workspace.key}/settings/integrations`} />

        <Page.Info>
          <Page.Eyebrow>Settings</Page.Eyebrow>
          <Page.Title>QuickBooks Online</Page.Title>
        </Page.Info>

        <Page.Actions>
          <QBOLogo src={qboIcon} />
        </Page.Actions>
      </Page.Header>

      <QBOSettingsPage />
    </Page>
  );
}
